import Vue from 'vue'
import Vuex from 'vuex'
import computer from './modules/computer'
import comment from './modules/comment'
import user from './modules/user'
import FileManager from '../router/views/documents/FileManager'
import modules from './modules'
import userAuth from './modules/userAuth'
import documentType from './modules/documentType'
import metadata from './modules/metadata'
import processes from './modules/processes'
import profiles from './modules/profiles'
import states from './modules/states'
import transitions from './modules/transitions'
import actions from './modules/actions'
import log from './modules/log'
import roles from './modules/roles'
import group from './modules/group'
import permissions from './modules/permissions'
import document from './modules/document'
import actionType from './modules/actionType'
//File manager
import settings from './modules/settings/store'
import tree from './modules/tree/store';
import modal from './modules/modal/store';
import manager from './modules/manager/store';
import messages from './modules/messages/store';
//Plugins
import { abilityPlugin } from './plugins/ability'
// main store
import state from './state';
import mutations from './mutations';
import getters from './getters';
import mainActions from './actions';

Vue.use(Vuex)
export { ability }
from './plugins/ability';

const store = new Vuex.Store({
    plugins: [abilityPlugin],
    modules: {
        ...modules,
        computer,
        comment,
        user,
        userAuth,
        documentType,
        metadata,
        processes,
        profiles,
        states,
        transitions,
        actions,
        group,
        log,
        roles,
        permissions,
        document,
        actionType,
        settings,
        left: manager,
        right: manager,
        tree,
        modal,
        messages,

    },
    state,
    mutations,
    actions: mainActions,
    getters,
    // Enable strict mode in development to get a warning
    // when mutating state outside of a mutation.
    // https://vuex.vuejs.org/guide/strict.html
    strict: process.env.NODE_ENV !== 'production',
})

Vue.use(FileManager, { store })

export default store